// GAVION wide screens: how wide <main> may grow, decided per route (one place, not per page).
// - "wide": data-dense screens (dashboard, lists, deals board, reports, dialer, email lists, to-do list) fill the
//   window up to 2880 px (a 34" 3440 × 1440 ultrawide minus the sidebar), then center.
// - "reading": forms, settings, profile, editors, training: the readable 1440 px cap they always had.
// Unknown routes keep the 1440 px cap (the previous behaviour). Nothing changes at ≤ 1440 px: both tiers are fluid
// below their cap and keep the same 24 px padding until 1920 px.

export type PageWidth = "wide" | "reading";

const WIDE: RegExp[] = [
  /^\/$/, // dashboard (rep and team views)
  /^\/(companies|contacts|deals)\/?$/, // leads, contacts and deals lists / board
  /^\/deals\/[^/]+(\/show)?\/?$/, // a deal opens as a dialog over the board
  /^\/rapports(\/.*)?$/, // reports index and every report, incl. Sessions
  /^\/appeler(\/(a-completer|historique))?\/?$/, // dialer, its to-do list, « Mes appels » (GAVION my-calls)
  /^\/courriels\/(campagnes|sequences|modeles|segments|demandes-arret|a-verifier)\/?$/, // email lists
  /^\/courriels\/campagnes\/(?!nouvelle$)[^/]+\/?$/, // a campaign's report
  /^\/reunions\/?$/, // meetings inbox
];

export const pageWidthFor = (pathname: string): PageWidth =>
  WIDE.some((r) => r.test(pathname)) ? "wide" : "reading";

export const MAIN_WIDTH_CLASS: Record<PageWidth, string> = {
  wide: "max-w-[2880px] min-[120rem]:px-8 min-[160rem]:px-10",
  reading: "max-w-[1440px]",
};
